import React from 'react';
import { Component } from 'reflux';
import { actions } from 'actions';
import { CountryStore } from 'stores/CountryStore';
import TableRow from '../table/Row';
import TableColumn from '../table/Column';

class CountryDropDown extends Component {
  state = { fields: [] }

  constructor(props) {
    super(props);

    this.mapStoreToState(CountryStore, this.countryChanged);
  }

  countryChanged = (fields) => ({ fields })

  componentWillMount() {
    actions.getCountries();
  }

  onChange = (evt) => {
    this.props.onChange(evt);
    this.props.handleSave(this.props.name,false);
  }

  render() {
    return (
      <TableRow>
        <TableColumn>
          <strong>{this.props.title}</strong>
        </TableColumn>
        <TableColumn>
          <span className="pull-right">
            <select onChange={this.onChange} style={{width: '150px'}} value={this.props.value.uid}>
              {this.state.fields.map((item) => (
                <option key={item.uid} value={item.uid}>{item.name}</option>
              ))}
            </select>
          </span>
        </TableColumn>
      </TableRow>
    );
  }
}

export { CountryDropDown };
